import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RepairFailModalComponent } from '../../compensate/repair-fail-modal/repair-fail-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-bus-seat-status-repair',
  templateUrl: './bus-seat-status-repair.component.html',
  styleUrls: ['./bus-seat-status-repair.component.scss'],
})
export class BusSeatStatusRepairComponent implements OnChanges {
  @Input() data: any;

  constructor(private dialog: MatDialog) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data.status_youtube === 'CannotBeRepaired')
      this.openCompensateYoutubeFail();
  }

  text() {
    const m: any = {
      UnderRepair: '正在修复',
      CannotBeRepaired: '无法修复',
      WalletRefund: '钱包退款',
    };
    return m[this.data?.status_youtube] || '';
  }

  color() {
    const m: any = {
      UnderRepair: '#FFC107',
      CannotBeRepaired: '#A5A5A5',
      WalletRefund: '#602369',
    };
    return m[this.data?.status_youtube] || '';
  }

  openCompensateYoutubeFail() {
    this.dialog.open(RepairFailModalComponent, {
      width: '590px',
      data: this.data,
      panelClass: 'overflow-dialog',
    });
  }
}
